import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/assabil-kernel/services/user-service';


@Component({
  selector: 'lean-menu',
  templateUrl: './lean-menu.component.html',
  styleUrls: ['./lean-menu.component.scss']
})
export class LeanMenuComponent implements OnInit {

  @Input() menu       : any = null;     
  @Input() shrinkMode : boolean = false;
  @Input() expanded   : boolean = true;

  @Output() onSelect = new EventEmitter<any>();

  constructor(
    public    userService         : UserService,  // should be public to be accessed from Html
    protected router              : Router,
    protected activatedRoute      : ActivatedRoute,
  ) { }

  ngOnInit() {
  }

  select(item : any) {
    this.userService.selectedMenu = item;
    if (item.route) {
      this.router.navigate([item.route], {relativeTo : this.activatedRoute});
    } else {
        this.onSelect.emit(item.id);
    }
  }

  getBlocPrefiix(bloc :any) : string{
      if (! bloc) return '.'
      if (!bloc.prefix) return bloc.title.substring(0,1);
      return bloc.prefix;
  }
 
  getMenuPrefix(){
    if (this.menu.prefix) return this.menu.prefix;
    return this.menu.title.substring(0,1);
  }


getMenuIcon(item :any) : string{
  if (item == this.userService.selectedMenu) return "assets/images/icons/menu-selected.png";
  return "assets/images/icons/menu.png";
}
getBlocIcon(item :any) : string{
  if (item == this.userService.selectedMenu) return "assets/images/icons/menu-bloc.png";
  return "assets/images/icons/menu-bloc.png";
}

}


